export default __webpack_public_path__ + "static/media/image29.32a603ec.jpg";